<template>
  <media-manager 
    v-bind:sourceId="sourceId_Resident"
    v-bind:title="title"
    v-bind:kiosks="kiosks"
    v-bind:defaultKioskId="defaultKioskId"
    v-bind:containers="containers"
    v-bind:defaultContainer="defaultContainer"
    v-bind:isAdminMode="isAdminMode"
    v-bind:toolbarColor="toolbarColor"
    v-bind:toolbarColorDark="toolbarColorDark"
  />

</template>

<script>
import appService from '@/app.service'
import MediaManager from '@/components/MediaManager'
import { GenieMediaSourceId, AppColor, KioskTypeId } from '@/config.js'
import { mapGetters } from 'vuex'

export default {
  name: 'ResidentMediaManager',
  components: {
    MediaManager
  },
  data() {
    return {
      toolbarColor: AppColor.ResidentLight,
      toolbarColorDark: AppColor.ResidentDark,
      sourceId_Resident: GenieMediaSourceId.Resident,
      kioskTypeId_Genie: KioskTypeId.Genie,

      kiosks: [],
      defaultKioskId: null,
      containers: [],
      defaultContainer: null
    }
  },
  computed: {
    ...mapGetters(['previousRoute', 'activeResident', 'activeResidentKioskItem', 'isResidentManager']),
    title () {
      if (this.isAdminMode) return null
      if (this.isResidentManager) return this.residentName
      else if (this.isFromResidentDashboard) return `${this.residentKioskName} / ${this.residentName}`
      else return this.residentName
    },
    isFromResidentDashboard () {
      return this.previousRoute.indexOf('ResidentDashboard') >= 0
        || (this.previousRoute.indexOf('Home') >= 0 && this.isResidentManager)
    },
    isAdminMode () {
      return !this.isFromResidentDashboard
    },
    residentContainer () {
      if (this.activeResident === null) return null
      return this.activeResident.container
    },
    residentName () {
      if (this.activeResident === null) return null
      return this.activeResident.name
    },
    residentKioskName () {
      if (this.isNullOrUndefined(this.activeResidentKioskItem)) return null
      return this.activeResidentKioskItem.serialNumber
    },
    activeContainer () {
      return this.isFromResidentDashboard
        ? {
          name: this.residentContainer,
          displayName: this.residentName
        }
      : null
    }
  },
  methods: {
    loadData () {
      const self = this

      //-- resident dashboard
      if (self.isFromResidentDashboard) {
        self.containers = [self.activeContainer]
        self.defaultContainer = self.activeContainer.name
      } else {
        appService.getKioskComboboxOptions(self.kioskTypeId_Genie).then(data => {
          if (data.errorSeverity > 0) self.handleError(data)
          else {
            self.kiosks = data.options
            self.defaultKioskId = 0
            self.defaultContainer = ''
          } 
        })
      }
    },

    handleError (result) {
      this.$error.show({
        text: result.errorMessage,
        severity: result.errorSeverity
      })
    }
  },
  created() {
    this.loadData()
  }
}
</script>
